import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p442450294435041280',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
